export default {
  name: "articlesProfileSection",
  data() {
    return {
      commands: [],
      selectedCommand: [],
    };
  },
  mounted() {
    console.log("test", this.$store.getters.getUserInfo.commands);
    setTimeout(() => {
      this.commands = this.$store.getters.getUserInfo.commands;
    }, 500);
  },
  //https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/Screenshot_from_2020-06-17_08-52-42_kg8mya
  //,Screenshot_from_2020-06-17_08-49-28_igqnwf,Screenshot_from_2020-06-17_08-42-28_fp3eji
  methods: {
    detailCommande(data) {
      console.log(data);
      this.selectedCommand = data.product;
    },
  },
};
